import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../Styling/Amazon_Order_item_mapping_Screen.css';
import { Base_URL } from '../url';

const AmzOrderItemMapping = () => {
  const [formData, setFormData] = useState({
    productTitle: '',
    skuAmazon: '',
    asinAmazon: '',
    empStdQty: '',
    erpStdSku: '',
    itemName: ''
  });

  const [amazonSkuList, setAmazonSkuList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Base URL - adjust this according to your environment
//   const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://your-api-base-url.com';

  // Fetch Amazon SKU dropdown data on component mount
  useEffect(() => {
    fetchAmazonSkuList();
  }, []);

  const fetchAmazonSkuList = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get(
        `${Base_URL}/Amazon_Screen_Request/GetAllAmazonSku`
      );
      setAmazonSkuList(response.data);
    } catch (err) {
      setError('Failed to load Amazon SKU list. Please try again.');
      console.error('Error fetching Amazon SKU:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    // Clear messages when user starts typing
    if (error) setError('');
    if (successMessage) setSuccessMessage('');
  };

  const validateForm = () => {
    if (!formData.skuAmazon) {
      setError('SKU Amazon is required');
      return false;
    }
    if (!formData.empStdQty) {
      setError('Emp Std Qty is required');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setSubmitLoading(true);
    setError('');
    setSuccessMessage('');

    // Prepare payload according to API requirements
    const payload = {
      productTitle: formData.productTitle,
      skuAmazon: formData.skuAmazon,
      asinAmazon: formData.asinAmazon,
      erpStdSku: formData.erpStdSku,
      itemName: formData.itemName
    };

    try {
      const response = await axios.post(
        `${Base_URL}/Amazon_Screen_Request/PostToAmzOrderItemMapping`,
        payload
      );
      
      setSuccessMessage('Data submitted successfully!');
      // Reset form after successful submission
      setFormData({
        productTitle: '',
        skuAmazon: '',
        asinAmazon: '',
        empStdQty: '',
        erpStdSku: '',
        itemName: ''
      });
    } catch (err) {
      setError(
        err.response?.data?.message || 
        'Failed to submit data. Please try again.'
      );
      console.error('Error submitting form:', err);
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      productTitle: '',
      skuAmazon: '',
      asinAmazon: '',
      empStdQty: '',
      erpStdSku: '',
      itemName: ''
    });
    setError('');
    setSuccessMessage('');
  };

  return (
    <div className="amz-order-item-mapping-container">
      <div className="amz-order-item-mapping-wrapper">
        <div className="amz-order-item-mapping-header">
          <h1 className="amz-order-item-mapping-title">
            Amazon Order Item Mapping
          </h1>
        </div>

        <div className="amz-order-item-mapping-card">
          {error && (
            <div className="amz-order-item-mapping-alert amz-order-item-mapping-alert-error">
              {error}
            </div>
          )}

          {successMessage && (
            <div className="amz-order-item-mapping-alert amz-order-item-mapping-alert-success">
              {successMessage}
            </div>
          )}

          <form onSubmit={handleSubmit} className="amz-order-item-mapping-form">
            <div className="amz-order-item-mapping-form-grid">
              {/* Row 1: Product Title and SKU Amazon */}
              <div className="amz-order-item-mapping-form-group">
                <label htmlFor="productTitle" className="amz-order-item-mapping-label">
                  Product Title
                </label>
                <input
                  type="text"
                  id="productTitle"
                  name="productTitle"
                  value={formData.productTitle}
                  onChange={handleInputChange}
                  className="amz-order-item-mapping-input"
                  placeholder="Enter product title"
                />
              </div>

              <div className="amz-order-item-mapping-form-group">
                <label htmlFor="skuAmazon" className="amz-order-item-mapping-label">
                  SKU Amazon <span className="amz-order-item-mapping-required">*</span>
                </label>
                <select
                  id="skuAmazon"
                  name="skuAmazon"
                  value={formData.skuAmazon}
                  onChange={handleInputChange}
                  className="amz-order-item-mapping-select"
                  required
                  disabled={loading}
                >
                  <option value="">
                    {loading ? 'Loading...' : 'Select SKU Amazon'}
                  </option>
                  {amazonSkuList.map((item) => (
                    <option key={item.skuId} value={item.amazonSku}>
                      {item.amazonSku}
                    </option>
                  ))}
                </select>
              </div>

              {/* Row 2: ASIN Amazon and Emp Std Qty */}
              <div className="amz-order-item-mapping-form-group">
                <label htmlFor="asinAmazon" className="amz-order-item-mapping-label">
                  ASIN Amazon
                </label>
                <input
                  type="text"
                  id="asinAmazon"
                  name="asinAmazon"
                  value={formData.asinAmazon}
                  onChange={handleInputChange}
                  className="amz-order-item-mapping-input"
                  placeholder="Enter ASIN Amazon"
                />
              </div>

              <div className="amz-order-item-mapping-form-group">
                <label htmlFor="empStdQty" className="amz-order-item-mapping-label">
                  ERP Std Qty <span className="amz-order-item-mapping-required">*</span>
                </label>
                <input
                  type="number"
                  id="empStdQty"
                  name="empStdQty"
                  value={formData.empStdQty}
                  onChange={handleInputChange}
                  className="amz-order-item-mapping-input"
                  placeholder="Enter quantity"
                  required
                  min="0"
                />
              </div>

              {/* Row 3: Item Name and ERP Std SKU */}
              <div className="amz-order-item-mapping-form-group">
                <label htmlFor="itemName" className="amz-order-item-mapping-label">
                  Item Name
                </label>
                <input
                  type="text"
                  id="itemName"
                  name="itemName"
                  value={formData.itemName}
                  onChange={handleInputChange}
                  className="amz-order-item-mapping-input"
                  placeholder="Enter item name"
                />
              </div>

              <div className="amz-order-item-mapping-form-group">
                <label htmlFor="erpStdSku" className="amz-order-item-mapping-label">
                  ERP Std SKU
                </label>
                <input
                  type="text"
                  id="erpStdSku"
                  name="erpStdSku"
                  value={formData.erpStdSku}
                  onChange={handleInputChange}
                  className="amz-order-item-mapping-input"
                  placeholder="Enter ERP Std SKU"
                />
              </div>
            </div>

            <div className="amz-order-item-mapping-button-group">
              <button
                type="submit"
                className="amz-order-item-mapping-button amz-order-item-mapping-button-primary"
                disabled={submitLoading || loading}
              >
                {submitLoading ? 'Submitting...' : 'Submit'}
              </button>
              <button
                type="button"
                onClick={handleReset}
                className="amz-order-item-mapping-button amz-order-item-mapping-button-secondary"
                disabled={submitLoading}
              >
                Reset
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AmzOrderItemMapping;